import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { translate } from "../i18n";
import { useForm, FormProvider } from 'react-hook-form';
import Step0PersonalInfo from './formSteps/company_form_steps/Step0PersonalInfo';
import Step1CompanyInfo from './formSteps/company_form_steps/Step1CompanyInfo';
import Step2Finalisation from './formSteps/company_form_steps/Step2Finalisation';
import { setFormField } from '../store/reducers/registrationSlice';
import { endpoints } from "../servics/apiEndpoints";

const steps = [
  'Informations personnelles',
  'Informations sur l’entreprise',
  'Activités & finalisation'
];

const CompanyFormSteps = ({ formFields, onFinalSubmit}) => {
  const dispatch = useDispatch();
  const language_code = useSelector(state => state.lang);

  // Old activityCountry implementation
  const iso2 = useSelector((s) => s.country.country?.label) || 'togo';
  const countryCode = iso2.toLowerCase();

  // New activityCountry implementation
    const activityCountry =
        useSelector(
            s =>
                s.country.activityCountry.label
                ||
                s.country.country.label
        );

  const methods = useForm({

    defaultValues: {
      firstName: formFields.firstName || '',
      lastName: formFields.lastName || '',
      email: formFields.email || '',
      telephone: formFields.telephone || '',
      isCooperative: formFields.isCooperative || '',
        // Champs invisibles
        gender:'not defined',
        isRegular: false,
        isCompany: true,
        isHero: false,
        platformSource: /Mobile|Android|iPhone/i.test(navigator.userAgent) ? 'mobile' : 'web',
        ipAddress: '',
        residenceCity: '',
        residenceCountry:'',
        activityCountry: '',
    },
    mode: 'onChange', // met à jour isValid en temps réel
    reValidateMode: 'onChange'
  });

  const { formState: { isValid }, handleSubmit } = methods;

  const [currentStep, setCurrentStep] = useState(0);

  const handleNext = () => setCurrentStep(prev => Math.min(prev + 1, steps.length - 1));
  const handleBack = () => setCurrentStep(prev => Math.max(prev - 1, 0));

  const renderStep = () => {
    switch (currentStep) {
      case 0:
        return (
          <Step0PersonalInfo
            dispatch={dispatch}
            formFields={formFields}
            language_code={language_code}
            translate={translate}
            fields={[
            'firstName',
            'lastName',
            'telephone',
            'email',
            'isCooperative'
          ]}
          />
        );
      case 1:
        return (
          <Step1CompanyInfo
            dispatch={dispatch}
            formFields={formFields}
            language_code={language_code}
            translate={translate}
            countryCode={activityCountry}
            fields={[
            'companyName',
            'companyCode',
            'companySector',
            'companyStatus',
            'companyAgroRealm',
            'responsabilityInCompany'
          ]}
          />
        );
      case 2:
        return (
          <Step2Finalisation
            dispatch={dispatch}
            formFields={formFields}
            language_code={language_code}
            translate={translate}
            countryCode={activityCountry}
            fields={[
              'isProducer',
              'isSpeculator',
              'isTrader',
              'isTransformer',
              'wishesWhenRegistering'
            ]}
          />
        );
      default:
        return null;
    }
  };

    useEffect(() => {
        const fetchGeoInfo = async () => {
            try {
                // const res = await fetch('https://ipapi.co/json/');
                // const res = await fetch('https://ipinfo.io/json?token=ae76313b250558');
                const res = await fetch(endpoints.geoInfo);
                const data = await res.json();

                // console.log("📍 Données géo récupérées :", data);
                methods.setValue('gender', 'not defined');
                methods.setValue('isCompany', true);
                methods.setValue('ipAddress', data.ip || '', { shouldValidate: true });
                methods.setValue('residenceCountry', data.country || '', { shouldValidate: true });
                methods.setValue('activityCountry', activityCountry || '', { shouldValidate: true });
                methods.setValue('residenceCity', data.city || '', { shouldValidate: true });
                methods.setValue('platformSource', /Mobile|Android|iPhone/i.test(navigator.userAgent) ? 'mobile' : 'web', { shouldValidate: true });

                dispatch(setFormField({ field: 'gender', value: 'not defined' }));
                dispatch(setFormField({ field: 'isCompany', value: true }));
                dispatch(setFormField({ field: 'ipAddress', value: data.ip || '' }));
                dispatch(setFormField({ field: 'residenceCountry', value: data.country || '' }));
                dispatch(setFormField({ field: 'activityCountry', value: activityCountry || '' }));
                dispatch(setFormField({ field: 'residenceCity', value: data.city || '' }));
                dispatch(setFormField({ field: 'platformSource', value: /Mobile|Android|iPhone/i.test(navigator.userAgent) ? 'mobile' : 'web' }));

            } catch (error) {
                console.error('❌ Erreur de géolocalisation IP :', error);
            }
        };

        fetchGeoInfo();
    }, []);



    return (
    <FormProvider {...methods}>
        <h4>{steps[currentStep]}</h4>
        {renderStep()}
        
        <div className="step-controls d-flex gap-10 mt-3">
          {currentStep > 0 && (
            <button type="button" className="btn btn-secondary" onClick={handleBack}>
              {translate('button', language_code.lang).back_step_button}
            </button>
          )}

          {currentStep < steps.length - 1 && (
            <button
              type="button"
              className="btn btn-primary"
              disabled={!isValid}
              onClick={handleNext}
            >
              {translate('button', language_code.lang).next_step_button}
            </button>
          )}

          {currentStep === steps.length - 1 && (
            <button type="submit"
                    className="btn btn-success"
                    disabled={!isValid}
                    onClick={handleSubmit(onFinalSubmit)} // Appel parent
                    >
              {translate('button', language_code.lang).submit_button}
            </button>
          )}
        </div>
    </FormProvider>
  );
};

export default CompanyFormSteps;
